<template>
    <div class="modal-mask">
        <div class="modal-content-container">
            <div class="new-provider-header">
                <div v-if="id">Editar fornecedor</div>
                <div v-else>Novo Fornecedor</div>
                <span v-on:click="close" class="material-icons new-provider-close-icon">cancel</span>
            </div>
            <div v-if="!loading" class="new-provider-body">
                <div class="new-provider-body-buttons">
                    <StandardButton
                        class="new-provider-buttons-size"
                        :action="handleOpenModalWhiteLabel"
                        :iconName="'palette'"
                        :text="'White Label'"
                    />
                    <StandardButton class="new-provider-buttons-size" :action="close" :iconName="'arrow_back'" :text="'Voltar'" />
                    <StandardButton class="new-provider-buttons-size" :action="save" :iconName="'save'" :text="'Salvar'" />
                </div>
                <div v-if="message" class="new-provider-error-message">
                    {{ message }}
                </div>
                <ProviderField :provider="provider" :getCnpjInfo="getCnpjInfo" :registration="registration" />
                <UserField v-if="!provider.id" :provider="provider" :profiles="profiles" />
                <StoreFields :highlightAdress="highlightAdress" :provider="provider" :states="states" :allCities="allCities" />
                <div>
                    <whiteLabelModal
                        v-if="showModalWhiteLabel"
                        :titleModal="'Configuração White Label'"
                        @close="showModalWhiteLabel = false"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProviderService from "@/services/v3/provider.service";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import StandardButton from "@/components/ui/buttons/StandardButton.vue";
import StandardInput from "@/components/ui/inputs/StandardInputV2.vue";
import StoreFields from "./newStore.vue";
import ProviderField from "./NewProvider.vue";
import UserField from "./NewUser.vue";
import BrasilApiService from "../../../services/BrasilApi";
import UserService from "@/services/v1/user.service";
import ProfileManagementService from "@/services/v3/management/profile.service";

//WHTE LABEL
import whiteLabelModal from "../../white-label-config/white-label-create-modal.vue";

export default {
    mixins: [loaderMixin],
    props: {
        registration: {
            type: Object,
        },
        id: {
            type: Number,
        },
    },
    components: {
        StoreFields,
        ValidationProvider,
        ValidationObserver,
        StandardButton,
        StandardInput,
        ProviderField,
        UserField,
        whiteLabelModal,
    },
    data() {
        return {
            users: [],
            categories: [],
            loading: true,
            message: null,
            stores: [],
            svc: new ProviderService(),
            user_svc: new UserService(),
            profile_svc: new ProfileManagementService(),
            brasilApi: new BrasilApiService(),
            states: [],
            allCities: [],
            profiles: [],
            provider: {
                manager: {},
                head_office: {},
                settings: [{ key: "CLIENT_RELEASE_STATUS" }],
                revenda_id: null,
            },
            isLoadingCnpj: false,
            highlightAdress: false,
            modal: {
                title: this.client_id ? `Editar Fornecedor` : "Novo Fornecedor",
                icon_title: "fas fa-users",
                cancel_text: "Voltar",
                style: {
                    width: "90%",
                    height: "fit-content",
                },
            },
            showModalWhiteLabel: false,
        };
    },
    watch: {
        "provider.social_reazon": function(val) {
            this.provider.head_office.social_reazon = val;
        },
        "provider.trading_name": function(val) {
            this.provider.head_office.trading_name = val;
            this.provider.name = val;
        },
        "provider.email": function(val) {
            if (this.provider.manager) {
                this.provider.manager.email = val;
            }
            this.provider.head_office.email = val;
        },
        "provider.cnpj": function(val) {
            this.provider.head_office.cnpj = val;
        },
        "provider.phone": function(val) {
            this.provider.head_office.phone = val;
            if (this.provider.manager) {
                this.provider.manager.phone = val;
            }
        },
    },
    methods: {
        getCnpjInfo(cnpj) {
            if (this.isLoadingCnpj || this.id) return;
            this.isLoadingCnpj = true;
            this.load_region_data().then((states) => {
                this.brasilApi.getCnpjInfo(cnpj).then((resp) => {
                    this.isLoadingCnpj = false;
                    this.$set(this.provider, "contact", resp.data.qsa[0].nome_socio);
                    this.$set(this.provider, "phone", resp.data.ddd_telefone_1);
                    this.$set(this.provider.head_office, "social_reazon", resp.data.razao_social);
                    this.$set(this.provider.head_office, "trading_name", resp.data.razao_social.replace("LTDA", ""));
                    console.log(this.states, "XXX");
                    this.$set(
                        this.provider.head_office,
                        "state",
                        states.find((s) => s.value == resp.data.uf)
                    );
                    this.$set(this.provider.head_office, "city", resp.data.municipio);
                    this.$set(this.provider.head_office, "zip_code", resp.data.cep);
                    this.$set(this.provider.head_office, "street", resp.data.logradouro + " " + resp.data.numero);
                    this.$set(this.provider.head_office, "district", resp.data.bairro);
                    this.states.forEach((element) => {
                        if (element.value.est_sigla == resp.data.uf) {
                            this.$set(this.provider.head_office, "state", {
                                ...element.value,
                                id: element.value.est_id,
                                name: element.value.est_nome,
                            });
                            this.allCities.forEach((element2) => {
                                if (
                                    element2.est_id == element.value.est_id &&
                                    element2.cid_nome.toLowerCase() == resp.data.municipio.toLowerCase()
                                ) {
                                    this.$set(this.provider.head_office, "city", {
                                        ...element2,
                                        id: element2.cid_id,
                                        name: element2.cid_nome,
                                    });
                                }
                            });
                            this.$forceUpdate();
                        }
                    });
                });
            });
        },
        load_profiles() {
            return this.profile_svc
                .list({
                    include_base: true,
                    tab: "base",
                    visibility: "provider",
                    per_page: "all",
                })
                .then((response) => response.data)
                .then((data) => {
                    this.profiles = data.data || data;
                });
        },
        load_region_data() {
            return this.user_svc
                .region_data()
                .then((response) => response.data)
                .then((data) => {
                    this.states = data.estados.map((c) => ({
                        value: c,
                        text: c.est_nome,
                    }));
                    this.allCities = data.cidades;
                    return this.states;
                });
        },
        remove(event, user) {
            event.preventDefault();
            event.stopPropagation();
            this.confirm_action({
                message: "Confirma remoção do usuário?",
                subtitle: `O usuário ${user.usu_nome} será removido!`,
                callback: () => {
                    this.svc.remove(this.provider.cli_id, user).then(() => this.load_users());
                },
            });
            return false;
        },
        save() {
            if (!this.provider.head_office.state) {
                this.highlightAdress = true;
                return;
            }
            if (!this.provider.id && (!this.provider.manager || !this.provider.manager.profile)) {
                this.message = "Perfil é obrigatório!";
                return;
            }
            this.present_loader("Salvando usuário...");
            this.message = null;
            let callback = (data) => {
                this.dismiss_loader();
                this.$swal.fire("Sucesso!", `Fornecedor ${this.id ? "atualizado" : "criado"} sucesso.`, "success");
                this.close(true);
            };
            let callback_error = (err) => {
                this.dismiss_loader();
                // this.message = 'Ops! Houve um erro ao salvar o Fornecedor, tente novamente mais tarde!'
                if (err.response && err.response.data && err.response.data.errors) {
                    let errors = err.response.data.errors;
                    this.message = Object.values(errors).flat()[0];
                } else {
                    this.message = "Ops! Houve um erro ao salvar o usuário, tente novamente mais tarde!";
                }
                ErrorHandlerService.handle(err, this.$store);
            };
            if (this.provider.id) {
                this.svc.update(this.provider).then(callback, callback_error);
            } else {
                this.svc.create(this.provider).then(callback, callback_error);
            }
        },
        add_new() {
            this.toggle_user({ store: this.stores[0], profile: {} });
        },
        close(reload = false) {
            this.$emit("close", reload);
        },
        handlekeydown(e) {
            if (e.key === "Escape") {
                this.close();
            }
        },
        load_provider() {
            if (this.id) {
                this.present_loader("Carregando fornecedor...");
                return this.svc
                    .show(this.id)
                    .then((response) => response.data)
                    .then((data) => {
                        this.provider = data;
                        this.provider.manager = {};
                        this.loading = false;
                        this.dismiss_loader();
                    })
                    .catch((error) => {
                        ErrorHandlerService.handle(error, this.$store);
                    });
            }
            if (this.registration) {
                this.provider = {
                    ...this.provider,
                    registration_id: this.registration.id,
                    cnpj: this.registration.cnpj,
                    email: this.registration.email,
                    manager: {
                        name: this.registration.name,
                        password: this.registration.password,
                        login: this.registration.email,
                    },
                    phone: this.registration.phone,
                };
                this.loading = false;
            } else this.loading = false;
        },
        process_stores() {
            this.users.forEach((u) => (u.store = this.stores.find((p) => p.loj_id == u.usu_idLoja)));
            this.$forceUpdate();
        },
        handleOpenModalWhiteLabel() {
            this.showModalWhiteLabel = true;
        },
    },
    mounted() {
        this.load_provider();
        this.load_region_data();
        this.load_profiles();
        window.addEventListener("keydown", this.handlekeydown);
    },
    beforeDestroy() {
        window.removeEventListener("keydown", this.handlekeydown);
    },
};
</script>

<style lang="scss" scoped>
@import "./new-provider.modalV2";
</style>
